// A METTRE DANS UN FICHIER(stock-control.js) JS QU'ON APELLE AVEC UN DEFER SUR LA PAGE OU L'INDICATEUR DE STOCK EST PRESENT

const variantElms = document.querySelectorAll('.product-variant');
let variantsObj = [];

variantElms.forEach(function(variantElm) {
  variantsObj.push(
    {
      id: variantElm.dataset.variantId,
      inventory_qty: variantElm.dataset.variantInventoryQty
    })
});

// console.log(variantElms);
 